import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAsoodehLandingPlant = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    viewBox='0 0 70 70'
    fill='none'
    {...props}
  >
    <rect width='100%' height='100%' fill='url(#asoodehLandingPlant_svg__a)' rx={8} />
    <defs>
      <pattern
        id='asoodehLandingPlant_svg__a'
        width={1}
        height={1}
        patternContentUnits='objectBoundingBox'
      >
        <use xlinkHref='#asoodehLandingPlant_svg__b' transform='scale(.00324)' />
      </pattern>
      <image
        xlinkHref='/images/icons/asoodeh-ead1695d.webp'
        id='asoodehLandingPlant_svg__b'
        width={309}
        height={309}
        preserveAspectRatio='xMidYMid slice'
      />
    </defs>
  </svg>
);
export default SvgAsoodehLandingPlant;
